var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business"},[_c('basepanel',[_c('h2',{staticClass:"bus-title"},[_vm._v("主营业务")]),_c('div',{staticClass:"outer-box"},[_c('lists',{attrs:{"categoryId":_vm.id,"prePath":_vm.prePath}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }